<template>
    <ModalErro v-if="showModal" title-modal="Erro" :message-error="messageError" @fechar="showModal = false" />
    <div class="container">
        <div class="page-header">
            <h2>Extrato de <span class="mes-atual">{{ mesAtual }}</span></h2>
            <div class="action-buttons">
                <router-link :to="`/alterar-senha/${$route.params.id}`" class="btn btn-primary">Alterar
                    senha</router-link>
                <router-link to="/admin" class="btn btn-secondary">Voltar</router-link>
            </div>
        </div>

        <div class="card">
            <div class="table-responsive">
                <table class="candidates-table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Idade</th>
                            <th>Telefone</th>
                            <th>Responsável</th>
                            <th>Data</th>
                            <th>Status</th>
                            <!-- <th>Ação</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(lead, index) in leads" :key="index">
                            <td>{{ lead.Nome }}</td>
                            <td>{{ lead.Idade }}</td>
                            <td>{{ lead.Telefone }}</td>
                            <td>{{ lead.Responsavel || " - " }}</td>
                            <td>
                                {{
                                    lead.Data_criacao != "" ? formatDateHour(lead.Data_criacao) : "-"
                                }}
                            </td>
                            <td>
                                <span class="status" :class="{ enviado: lead.Sincronizado }">
                                    {{ lead.Sincronizado ? "Enviado" : "Pendente" }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="leads.length === 0" class="empty-state">
                    <p class="margin-bottom-40px">Nenhum lead cadastrado ainda.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { api } from "../services/api";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRoute } from 'vue-router';
import ModalErro from "../components/ModalErro.vue";

const route = useRoute();

const leads = ref([]);
const online = ref(navigator.onLine);
const dataInicial = ref("");
const dataFinal = ref("");
const showModal = ref(false);
const messageError = ref('');


const leadsNaoEnviados = computed(() => {
    return leads.value.filter((c) => c.Sincronizado == 1).length;
})

onMounted(async () => {
    carregarLeads();
    window.addEventListener("online", updateOnlineStatus());
    window.addEventListener("offline", updateOnlineStatus());

})
onBeforeMount(() => {
    window.removeEventListener("online", updateOnlineStatus());
    window.removeEventListener("offline", updateOnlineStatus());
})

const mesAtual = computed(() => {
    return new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(new Date());
});

function updateOnlineStatus() {
    online.value = navigator.onLine;
}

async function carregarLeads() {
    try {
        let res = await api.getLeadsAdminMes();
        leads.value = res.leads;
    } catch (error) {
        console.log("Error", error);
    } finally {
        setTimeout(() => (syncMessage = ""), 5000);
    }
}

const formatDateHour = (dateString) => {
    return new Date(dateString).toLocaleString("pt-BR", {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
}
</script>
